import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.724 1.053A.5.5 0 018 1.5v12a.5.5 0 01-.8.4L3.333 11H1.5A1.5 1.5 0 010 9.5v-4A1.5 1.5 0 011.5 4h1.833L7.2 1.1a.5.5 0 01.524-.047zM7 2.5L3.8 4.9a.5.5 0 01-.3.1h-2a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h2a.5.5 0 01.3.1L7 12.5v-10zm7.854 2.646a.5.5 0 010 .708L13.207 7.5l1.647 1.646a.5.5 0 01-.708.708L12.5 8.207l-1.646 1.647a.5.5 0 01-.708-.708L11.793 7.5l-1.647-1.646a.5.5 0 01.708-.708L12.5 6.793l1.646-1.647a.5.5 0 01.708 0z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgSpeakerOff = styled(BaseComponent)`
  outline: none;
`
export default SvgSpeakerOff
